export const environment = {
  production: true,
  url: 'https://pruebas.nomiexpress.com',
  api: 'https://api.nomiexpress.com/api',
  apiAE: 'https://api.acceso.express',
  apiCF2: 'https://ace.acexpress.com.mx',
  apiCF1: 'https://rf.acceso.express',
  auth: 'https://acexpress.com.mx',
  hubUrl: 'https://accesoexpress.nomiexpress.com'
};
